import React, { useState } from 'react';
import { Toaster } from 'sonner';
import { Plus } from 'lucide-react';
import { TopBar } from './components/TopBar';
import { BottomNav } from './components/BottomNav';
import { FamilyTree } from './components/Tree/FamilyTree';
import { MemoryPanel } from './components/MemoryPanel/MemoryPanel';
import { StoriesTimeline } from './components/Stories/StoriesTimeline';
import { AddMemberModal } from './components/AddMemberModal';
import { FamilyMember } from './data/family';
export function App() {
  const [activeTab, setActiveTab] = useState<'tree' | 'stories'>('tree');
  const [selectedMember, setSelectedMember] = useState<FamilyMember | null>(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  return <div className="relative w-full h-screen bg-warm-bg overflow-hidden flex flex-col font-sans selection:bg-warm-cyan/30" data-id="element-0">
      <Toaster position="top-center" data-id="element-1" />

      <TopBar activeTab={activeTab} setActiveTab={setActiveTab} data-id="element-2" />

      <main className="flex-1 relative w-full h-full" data-id="element-3">
        {activeTab === 'tree' ? <FamilyTree selectedId={selectedMember?.id || null} onSelect={setSelectedMember} data-id="element-4" /> : <div className="w-full h-full overflow-y-auto bg-warm-bg relative" data-id="element-5">
            <div className="absolute inset-0 bg-noise z-0 fixed" data-id="element-6" />
            <div className="relative z-10" data-id="element-7">
              <StoriesTimeline data-id="element-8" />
            </div>
          </div>}
      </main>

      <MemoryPanel member={selectedMember} onClose={() => setSelectedMember(null)} data-id="element-9" />

      <BottomNav activeTab={activeTab} setActiveTab={setActiveTab} data-id="element-10" />

      {/* Floating Add Button */}
      <button onClick={() => setIsAddModalOpen(true)} className="fixed bottom-24 md:bottom-8 right-6 z-40 bg-warm-cyan text-warm-bg px-5 py-3.5 rounded-full shadow-warm flex items-center gap-2 font-medium hover:scale-105 hover:shadow-glow transition-all" data-id="element-11">
        <Plus className="w-5 h-5" data-id="element-12" />
        <span className="hidden sm:inline" data-id="element-13">Add Member</span>
      </button>

      <AddMemberModal isOpen={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} data-id="element-14" />
    </div>;
}